const $ = jQuery.noConflict();

class Slider {
    constructor( selector, args = {} ) {
        this.selector = selector;
        this.args = args;
    }

    getDefaultSlickSettings() {
        return {
            dots: false,
            arrows: true,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            pauseOnHover: false,
            speed: 600,
        }
    }

    /**
     * Override our default slick settings with args provided to the class.
     */
    getSlickSettings() {
        return Object.assign( {}, this.getDefaultSlickSettings(), this.args );
    }

    init() {
        let settings = this.getSlickSettings();
		console.log(settings);
		console.log(this.selector);
        let selector = $( this.selector + ':not(.slick-initialized)' );
		console.log(selector);
		console.log(selector.length);

        if ( selector.length ) {
            selector.slick( settings );
        }

        if (undefined !== settings.updateCounter && true ===settings.updateCounter) {
            selector.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
                if (event.target.nextElementSibling) {
                    let currentCounter = event.target.nextElementSibling.querySelector('.slickCurrent');

                    if(null !== currentCounter) {
                        let counter = nextSlide + 1;

                        if (counter < 10) {
                            counter = '0' + counter;
                        }
                        
                        currentCounter.textContent = counter;
                    }
                }
            });
        }

        if (undefined !== settings.progressBar && true ===settings.progressBar) {
            selector.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
                if (event.target.parentElement) {
                    let progressBar = event.target.parentElement.querySelector('.progress-bar');
                    let numberVisible = event.target.querySelectorAll('.slick-slide.slick-active');

                    if (progressBar) {
                        progressBar.style.transform = 'scaleX(' + Math.round(((nextSlide + 1) / slick.slideCount) * 100) / 100 + ')';
                    }
                }
            });
        }
    }
}

const SimpleSlider = new Slider('.gallery-slider__slider');
const TestimonialSlider = new Slider('.testimonial-slider');

const FluidSlider = new Slider(
    '.gallery-slider__slider-fluid', 
    {
        centerMode: true,
        variableWidth: true,
        responsive: [
            {
                breakpoint: 1290,
                settings: {
                    centerMode: false,
                    variableWidth: false,
                },
            },
        ],
    }
);
const StaffSlider = new Slider(
    '.block-staff__slider', 
    {
        dots: false,
        arrows: true,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        pauseOnHover: false,
        speed: 600,
    }
);
const NewsBarSlider = new Slider(
    '.block-news-bar__slider', 
    {
        dots: false,
        arrows: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        pauseOnHover: false,
        speed: 600,
        updateCounter: true
    }
);
const CardSlider = new Slider(
    '.block-card-slider__slider', 
    {
        dots: false,
        arrows: true,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        pauseOnHover: false,
        speed: 600,
        progressBar: true,
        responsive: [
            {
                breakpoint: 1320,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    }
);
const RelatedEventsSlider = new Slider(
    '.block-related-events__slider',
    {
        dots: false,
        arrows: true,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        pauseOnHover: false,
        speed: 600,
        progressBar: true,
        responsive: [
            {
                breakpoint: 1320,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    }
);
export { SimpleSlider, TestimonialSlider, FluidSlider, StaffSlider, NewsBarSlider, CardSlider, RelatedEventsSlider };